/***
 * Created on 2024/4/23
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../../../../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";

function QnapAuthSetupSuccess({state, ...props}) {
    const { t } = useTranslation();

    const onSignOut = () => {
        location.href = '/signout';
    }

    return (
        <ModalDialog {...props} title={t('@Set up through QNAP Authenticator@')} submitText={t('@Sign in Again@')} hideCancel={true} submitAction={onSignOut}>
            <div className="dialog-content dialog-content--two-step">
                <div className="dialog__sub-title color-primary">{t('@2 Step Verification Set Up Successfully!@')}</div>

                {state.method === 'qrcode' && <p>{t('@Sign in by scanning the QR code on the sign-in page with your QNAP Authenticator app.@')}</p>}
                {state.method === 'approval' && <p>{t("@During sign in, open QNAP Authenticator on your paired device and tap 'Approve' to seamlessly complete the process.@")}</p>}
                {state.method === 'verification' && <p>{t("@Receive push notifications on your paired device and enter the verification code in the app during login.@")}</p>}


                <p>{t('@Sign in with your QNAP ID in all your browsers, QNAP mobile apps, and KoiBot again.@')}</p>
            </div>
        </ModalDialog>
    );
}

export default QnapAuthSetupSuccess;